import React, { useEffect } from "react"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { Steps } from "../journey/step-library"
import { useMedicalInfoWorkflow } from "../../hooks/useMedicalInfoFlow"
import { useCurrentUser } from "../../../context/user/UserContext"

const step = Steps.SHOW_MEDICAL_QUESTIONS_DECISION
export default function ShowMedicalQuestionsDecisionStep(): JSX.Element {
  const { IsAMAB, IsAFAB } = useMedicalInfoWorkflow()
  const { isUsa } = useCurrentUser()
  const showMedicalQuestion = isUsa && (IsAMAB || IsAFAB) ? "YES" : "NO"

  const { setNextStep } = useStateMachine(step, showMedicalQuestion)
  useEffect(() => {
    setNextStep(step, showMedicalQuestion)
  })
  return <></>
}
